import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import './Alert.scss'
import CheckIcon from '../../assets/CheckIcon'

function Alert(props) {
  const { alertType, alertMessage, success, onClose, duration } = props
  const [showAlert, setShowAlert] = useState(true)

  const handleClose = () => {
    setShowAlert(false)

    if (onClose) {
      onClose()
    }
  }

  useEffect(() => {
    setShowAlert(true)
  }, [alertMessage])

  useEffect(() => {
    if (!showAlert) return

    const timeout = setTimeout(() => {
      handleClose()
    }, duration || 5000)

    return () => clearTimeout(timeout)
  }, [showAlert, duration])

  if (!showAlert) return null

  return (
    <div className={`alert dFlex aiCenter ${alertType}`} role="alert">
      {success && <CheckIcon />}
      <span className="alertMessage">{alertMessage}</span>
      <button
        type="button"
        className="alertClose"
        onClick={handleClose}
        aria-label="Close alert"
      >
        &times;
      </button>
    </div>
  )
}

Alert.propTypes = {
  alertType: PropTypes.string,
  alertMessage: PropTypes.string,
  success: PropTypes.bool,
  onClose: PropTypes.func,
  duration: PropTypes.number,
}

export default Alert
